export default __webpack_public_path__ + "static/media/imagebkg.7b6d532f.png";